import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

interface IconProps {
    icon: IconDefinition;
    iconColor?: string;
    fontSize?: 'small' | 'medium' | 'large';
    className?: string;
    style?: React.CSSProperties;
    color?: string;
    onClick?: () => void;
}

const Icon: React.FC<IconProps> = ({
    icon,
    iconColor,
    fontSize,
    className,
    style,
    color,
    onClick,
}) => {
    const size = fontSize === 'small' ? 'sm' : fontSize === 'large' ? 'lg' : '1x';
    const finalColor = color || iconColor;

    return (
        <FontAwesomeIcon
            icon={icon}
            className={className}
            style={style}
            color={finalColor}
            size={size}
            onClick={onClick}
        />
    );
};

export default Icon; 